<template>
  <div class="container-reports">
    <div class="table-option column mb-2 col-md-12 justify-content-left p-0">
      <b-modal
        centered
        ref="dialogWait"
        no-close-on-backdrop
        no-close-on-esc
        size="sm"
        hide-header
        hide-footer
      >
        <div class="center-xs">
          <spinner />
        </div>
        <div class="center-xs pt-3">
          {{ currentLoadingMessage }}
        </div>
      </b-modal>

      <div class="w-100 row justify-content-end align-items-center">
        <b-button
          @click="$refs.dataTable ? $refs.dataTable.importJSON() : ''"
          size="sm"
          variant="outline-secondary"
          class="m-1 mb-1 font-weight-regular"
        >
          <upload-icon style="font-size: 1.1em; vertical-align: -3%" />
          Importar Configuração
        </b-button>
        <b-button
          class="align-items-center font-weight-regular"
          :class="showDownloadOptions ? null : 'collapsed'"
          size="sm"
          id="downloads-options"
          variant="outline-secondary"
          :aria-expanded="showDownloadOptions ? 'true' : 'false'"
          aria-controls="collapse-downloads"
          @click="showDownloadOptions = !showDownloadOptions"
        >
          Baixar Planilha
        </b-button>
      </div>
      <b-collapse
        id="collapse-downloads"
        v-model="showDownloadOptions"
        class="mt-1 download-options"
      >
        <download-table-content
          :downloadCSV="$refs.dataTable ? $refs.dataTable.downloadCSV : ''"
          :downloadXLSX="$refs.dataTable ? $refs.dataTable.downloadXLSX : ''"
          :downloadPDF="$refs.dataTable ? $refs.dataTable.downloadPDF : ''"
          :downloadJSON="$refs.dataTable ? $refs.dataTable.downloadJSON : ''"
          class="py-2 py-lg-2"
        />
      </b-collapse>

      <div class="w-100">
        <b-button
          rounded
          size="sm"
          variant="secondary"
          class="m-1 align-items-center"
          @click="addRowDap"
          :class="{ disabled: hasUncompletedRow }"
        >
          Adicionar DAP
        </b-button>
        <b-button
          @click="deleteRowBtn"
          rounded
          size="sm"
          variant="secondary"
          class="m-1 align-items-center"
          :class="{ disabled: !itemsSelected.length }"
        >
          Deletar DAP
        </b-button>

        <b-button
          @click="itemsSelected.length ? replyRows() : ''"
          rounded
          size="sm"
          variant="secondary"
          class="m-1 align-items-center"
          :class="{ disabled: !itemsSelected.length || hasUncompletedRow }"
        >
          Clonar linha(s)
        </b-button>

        <b-button
          @click.prevent="saveTable"
          rounded
          size="sm"
          :variant="changedTableData ? 'success' : ''"
          class="m-1 align-items-center"
        >
          Salvar
        </b-button>

        <p class="last-update-farm">
          Última modificação {{ lastUpdate }} por {{ editorName }}
        </p>
      </div>
    </div>
    <!-- max-height-table="58vh" -->
    <data-table
      ref="dataTable"
      editable
      selectable
      move-rows
      sticky-header
      max-height-table="58vh"
      :left-frozen-columns="leftFrozenColumns"
      :static-columns="staticColumns"
      :table-data="tableData"
      :file-prefix="title"
      @update-selected-items="updateSelectedItems"
      @update-table-data="updateTableData"
      :is-reactive="true"
    />
    <!-- @add-new-row="addRowDap()" -->
    <b-modal
      ref="farmsHasSectorModal"
      centered
      size="sm"
      ok-title="Salvar"
      cancel-title="Cancelar"
      ok-variant="danger"
      @ok="submit"
      @cancel="closeItemsWithSectorsModal"
      title="Atenção!"
    >
      <div class="modal-form">
        <div class="title-modal-info">
          Caso seja realizado alguma alteração nos dados de DAP do cultivar, ao
          salvar será necessário editar os setores que possuem esse cultivar
          para que seja reacalculado os dados de manejo.
        </div>
      </div>
    </b-modal>
    <b-modal
      ref="notSaveEmptyFarmModal"
      centered
      size="sm"
      ok-title="Estou ciente"
      ok-variant="danger"
      @ok="closeEmptyFarmModal"
      ok-only
      title="Atenção!"
    >
      <div class="modal-form">
        <div class="title-modal-info">
          Antes de apagar os dados, será necessário primeiro desvincular esse
          cultivar dos setores.
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { create } from "../../../../api/modules/farms_dap/useCases/createFarmsDap";
import { showFarmsDapByIdFarmUseCase } from "../../../../api/modules/farms_dap/useCases/showFarmsDapByIdFarm";
import { checkIfFarmHasSector } from "../../../../api/modules/farms_dap/useCases/checkIfHasSector";
import DataTable from "../../../components/shared/table/DataTable.vue";
import DownloadTableContent from "../../../components/shared/table/DownloadTableContent.vue";
import table from "@/mixins/table";
import managementSectorsActions from "@/mixins/managementSectorActions.js";
import { cookies } from "../../../components/cookies";
import { farmUseCase } from "../../../../api/modules/farm/useCases";

export default {
  name: "SpreadSheet",
  mixins: [table, managementSectorsActions],
  props: {
    idFarm: {
      required: true,
      type: Number,
    },
    editorName: {
      type: [String, Boolean],
      required: true,
      default: () => "---",
    },
    lastUpdate: {
      type: String,
      required: true,
      default: () => "xx/xx/xxxx",
    },
    title: {
      required: false,
      type: String,
      default: function (props) {
        return `Cultivar ${props.idFarm}`;
      },
    },
  },
  components: {
    DataTable,
    DownloadTableContent,
  },
  created() {
    // console.log("created farms");
    // debugger
  },
  data() {
    return {
      loading: false,
      currentLoadingMessage: "",
      showDownloadOptions: false,
      itemsSelected: [],
      fertilizersList: [
        { id: 0, fertilizer_name: "ADUBO1", isSpecial: false },
        { id: 1, fertilizer_name: "ADUBO2", isSpecial: false },
        { id: 2, fertilizer_name: "ADUBO3", isSpecial: true },
        { id: 3, fertilizer_name: "ADUBO4", isSpecial: false },
      ],
      tableData: [], //data for table to display
      tableDataUnchanged: [], //data for table to display
      // qtdFertilizerCols: 6,
      leftFrozenColumns: [
        {
          title: "DAP",
          field: "DAP",
          sorter: "number",
          minWidth: 90,
          width: 90,
          headerSort: true,
          accessorDownload: (val) => val,
        },
      ],
      staticColumns: [
        {
          title: "Kc",
          field: "KC",
          minWidth: 90,
          width: 90,
          tooltip_text: "É o KC da planta",
          tooltip: (cell) => cell._cell.column.definition.tooltip_text,
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          validator: (cell, value) => (value && value >= 0) || value === "",
        },
        {
          title: "Estresse",
          field: "STRESS",
          editor: "select",
          minWidth: 130,
          maxWidth: 130,
          accessorDownload: this.booleanFormatter,
          tooltip_text: "É o estresse da planta",
          headerTooltip: (header) => header._column.definition.tooltip_text,
          tooltip: (cell) => cell._cell.column.definition.tooltip_text,
          formatter: (cell) => this.booleanFormatter(cell.getValue()),
          editorParams: {
            values: [0, 1],
            listItemFormatter: function (value, title) {
              return title ? "Sim" : "Não";
            },
          },
        },
        {
          title: "Projeção de Rama (m)",
          field: "BRANCH",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          validator: (cell, value) => (value && value > 0) || value === "",
          editorParams: {
            min: 0,
          },
        },
        {
          title: "Profundidade de Raiz (cm)",
          field: "DEPTH_ROOT",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          validator: (cell, value) => (value && value > 0) || value === "",
          editorParams: {
            min: 0,
          },
        },
        {
          title: "Condutividade Limite (dS)",
          field: "CONDUCTIVITY_LIMIT",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          validator: (cell, value) => (value && value > 0) || value === "",
          editorParams: {
            min: 0,
          },
        },
        {
          title: "Fator de Disponibilidade Crítica",
          field: "AVAILABILITY",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          validator: (cell, value) => (value && value > 0) || value === "",
          editorParams: {
            min: 0,
            max: 1,
          },
        },
        {
          title: "Fator de Redução de Precipitação",
          field: "PRECIPITATION",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          validator: ["min:0", "max:1"],
          editorParams: {
            min: 0,
            max: 1,
          },
        },
      ],
    };
  },
  mounted() {
    this.loadFarmsDap();
    window.onclick = (event) => {
      if (
        event.target.id != "collapse-downloads" &&
        event.target.id != "downloads-options" &&
        this.showDownloadOptions
      ) {
        this.showDownloadOptions = false;
      }
    };
  },
  computed: {
    changedTableData() {
      const hasLengthChanged =
        this.tableDataUnchanged.length !== this.tableData.length;

      const currentTableValues = this.tableData
        .map((row) => {
          return Object.values(row);
        })
        .flat();

      const startTableValues = this.tableDataUnchanged
        .map((row) => {
          return Object.values(row);
        })
        .flat();

      const hasUpdatedAnyColumn = currentTableValues.findIndex((val, index) => {
        return Number(val) !== Number(startTableValues[index]);
      });

      return hasLengthChanged || hasUpdatedAnyColumn >= 0;
    },
    lastRowItem() {
      return this.tableData[this.tableData.length - 1];
    },
    hasUncompletedRow() {
      return this.tableData.find((item) => this.hasNullAttribute(item));
    },
  },

  watch: {
    loading: {
      handler(newValue) {
        if (newValue) {
          this.$refs.dialogWait.show();
        } else {
          this.$refs.dialogWait.hide();
        }
      },
    },
    tableData: {
      handler(newValue) {
        const tempTableData = this.filterMultiCycledDap(newValue);

        if (tempTableData.length !== newValue.length) {
          this.updateTableData(tempTableData);
        }
      },
      deep: true,
    },
  },

  methods: {
    async generateManagement() {
      try {
        if (!this.idFarm) {
          return;
        }

        this.loading = true;
        this.currentLoadingMessage =
          "Procurando setores atrelados a este cultivar...";
        const managementSectors = await this.getManagementSectors({
          ID_FARM: this.idFarm,
        });

        if (managementSectors && managementSectors.length) {
          this.currentLoadingMessage =
            "Recalculando setores dependentes deste cultivar...";
          await this.recalcSectorsManagement(managementSectors);
        }

        this.loading = false;
        alert("Sucesso ao realizar calculo de manejo", "s");
      } catch (e) {
        this.loading = false;
        alert("Erro ao realizar calculo de manejo", "e");
        console.log(e);
      }
    },

    async saveTable() {
      if (this.hasUncompletedRow) {
        this.alertUncompletedRow();

        return false;
      } else {
        await this.submit();

        await this.generateManagement();
        this.tableDataUnchanged = JSON.parse(JSON.stringify(this.tableData));
        return true;
      }
    },
    async saveTableAndCloseModal() {
      if (!(await this.saveTable())) {
        return;
      }

      this.emitSavedTable();
    },
    emitSavedTable() {
      this.$emit("table-saved", true);
    },
    closeItemsWithSectorsModal() {
      this.$refs.farmsHasSectorModal.hide();
    },
    closeEmptyFarmModal() {
      this.$refs.notSaveEmptyFarmModal.hide();
    },
    alertUncompletedRow() {
      alert("Termine de preencher a linha incompleta!");
    },
    replyRows(between = null) {
      if (!between && !this.hasUncompletedRow) {
        let newItems = [];
        this.itemsSelected
          .sort((a, b) => a.DAP - b.DAP)
          .forEach((item, index) =>
            newItems.push({
              ...item,
              DAP: this.tableData.length + index,
            })
          );
        this.tableData = [...this.tableData, ...newItems];
      } else if (this.hasUncompletedRow) {
        this.alertUncompletedRow();
      }
    },
    updateSelectedItems(selectedItems) {
      this.itemsSelected = selectedItems;
    },
    filterMultiCycledDap(tableData) {
      const validTableData = [];

      for (let i = 0; i < tableData.length; i++) {
        const current = tableData[i];

        if (current.DAP === i) {
          validTableData.push(current);
        } else {
          alert("Cultivar com erro de ciclo repetido, salve-o novamente", "e");

          return validTableData;
        }
      }

      return validTableData;
    },
    updateTableData(tableData) {
      this.tableData = tableData;
    },
    hasNullAttribute(obj) {
      return !!Object.values(obj).filter((att) => att === null || att === "")
        .length;
    },
    addRowDap() {
      if (!this.hasUncompletedRow) {
        const newDAP = this.tableData.length;
        this.tableData = [
          ...this.tableData,
          {
            DAP: newDAP,
            KC: null,
            STRESS: null,
            BRANCH: null,
            DEPTH_ROOT: null,
            CONDUCTIVITY_LIMIT: null,
            AVAILABILITY: null,
            PRECIPITATION: null,
          },
        ];
      } else {
        this.alertUncompletedRow();
      }
    },
    deleteRowBtn() {
      const removeIndexes = this.itemsSelected.map((el) => el.DAP);
      removeIndexes.map((removeIndex) => {
        this.tableData = this.tableData.filter(
          (data) => data.DAP != removeIndex
        );
      });
      this.tableData.map((data, i) => (data.DAP = i));
    },
    loadFarmsDap() {
      showFarmsDapByIdFarmUseCase
        .execute(this.idFarm)
        .then((resp) => {
          this.tableData = resp[0];
          this.tableDataUnchanged = JSON.parse(JSON.stringify(this.tableData));
        })
        .catch(console.error);
    },
    async submit() {
      let farm_data = [];
      for (let farm of this.tableData) {
        let obj = {
          FERTILIZER_DAP: [],
        };
        let keys = Object.entries(farm);
        keys.map(([key, value]) => {
          Object.assign(obj, {
            [key]: value,
          });
        });
        farm_data.push(obj);
      }

      await new Promise((resolve, reject) => {
        create
          .execute(farm_data, this.idFarm)
          .then(async () => {
            alert("Tabela salva com sucesso", "s");
            resolve();

            await farmUseCase().updateFkEditor.execute(
              this.idFarm,
              cookies.get("ID")
            );
            await farmUseCase().updateFarmTimeById.execute(this.idFarm);
          })
          .catch((err) => {
            console.error(err.message);
            reject();
          });
      });
    },
  },
};
</script>
<style scoped>
.download-options {
  position: absolute;
  background: white;
  padding: 5px;
  right: 0;
  z-index: 99;
  min-width: 10em;
  max-width: 15em;
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.1s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 4px;
}
.last-update-farm {
  margin-right: 0;
  text-align: right;
  font-size: 0.72em;
  color: var(--text-gray-primary);
}
</style>
